// extracted by mini-css-extract-plugin
export var cartContainer = "_gu-4";
export var gray = "_gu-1";
export var itemContainer = "_gu-2";
export var itemDetails = "_gu-3";
export var strong = "_gu-0";